module.exports = __webpack_public_path__ + "img/stylus.87358283.png";